// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/ManagementDDLjdbc/styles.css
// module id = 2451
// module chunks = 193